export const navCustomizerData = [
    {
        id: 2,
        link: "https://support.pixelstrap.com/",
        image: 'medical-kit.png',
        title: 'Support'
    },
    {
        id: 3,
        link: "https://docs.pixelstrap.net/admin/yuri/document/",
        image: 'setting-2.png',
        title: 'Document'
    },
    {
        id: 4,
        link: "https://admin.pixelstrap.net/yuri/template/landing-page.html",
        image: 'setting-5.png',
        title: 'Check Features'
    },
    {
        id: 5,
        link: "https://themeforest.net/user/pixelstrap/portfolio",
        image: 'like-tag.png',
        title: 'Buy Now'
    },
];

export const layoutTypeData = [
    { type: "ltr", label: "LTR" },
    { type: "rtl", label: "RTL" },
    { type: "box-layout", label: "Box" },
];

export const lightColorOptions = [
    { name: "color-1", primary: "#009DB5", secondary: "#F94C8E" },
    { name: "color-2", primary: "#898121", secondary: "#4C4B16" },
    { name: "color-3", primary: "#31C6D4", secondary: "#EF6262" },
    { name: "color-4", primary: "#FF7676", secondary: "#FF4B91" },
    { name: "color-5", primary: "#8fa552", secondary: "#8e49dd" },
    { name: "color-6", primary: "#BA704F", secondary: "#C8AE7D" },
];

export const darkColorOptions = [
    { name: "color-1", primary: "#009DB5", secondary: "#F94C8E" },
    { name: "color-2", primary: "#898121", secondary: "#4C4B16" },
    { name: "color-3", primary: "#31C6D4", secondary: "#EF6262" },
    { name: "color-4", primary: "#FF7676", secondary: "#FF4B91" },
    { name: "color-5", primary: "#8fa552", secondary: "#8e49dd" },
    { name: "color-6", primary: "#BA704F", secondary: "#C8AE7D" },
];

export const mixLayoutData = [
    { value: 'dark-sidebar', headerClass: 'bg-light', sidebarClass: 'bg-dark', bodyClass: 'bg-light' },
    { value: 'dark-only', headerClass: 'bg-dark', sidebarClass: 'bg-dark', bodyClass: 'bg-dark' },
];